module.exports = __webpack_public_path__ + "static/media/supervisor-no-departments.b17d5703.png";